import { m as r } from "./math-trunc.js";
var t = function t(_t) {
  var n = +_t;
  return n != n || 0 === n ? 0 : r(n);
};
export { t };